import useFlashMessage, {
  withFlashMessage,
} from '@core/components/FlashMessage';

const withFlashMessaging = withFlashMessage;

export const useFlashMessaging = useFlashMessage;

export default withFlashMessaging;
